import { Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { OLBackIcon } from "components/CustomIcons/OLBackIcon";
import { LoadingInterceptor } from "components/LoadingInterceptor/LoadingInterceptor";
import { useGlobalManagement } from "globalManagement";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  selectImportedResources,
  setImported,
} from "reduxState/globalManagement/globalManagement";
import { links } from "utilities/links";
import { useStyles } from "./styles";
import { SuccessfulImports } from "./SuccessfulImports";
import { Tab } from "./Tabs/Tabs";
import { UnSuccessfulImports } from "./UnsuccessfulImports";
import { ImportResults, isAnyTableValue } from "./utils";

export type Imported = { [key in Tab]?: any[] };

export const ConfigImportList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [importData, setImportData] = useState<ImportResults>({});
  const dispatch = useAppDispatch();
  const { message } = useMessage();
  const classes = useStyles();
  const navigate = useNavigate();
  const { addGlobalConfigBatch } = useGlobalManagement();
  const importedResources = useAppSelector(selectImportedResources);

  useEffect(() => {
    if (importedResources) {
      // Batch add resources
      addGlobalConfigBatch(importedResources).then((imported) => {
        // Update redux import
        dispatch(setImported(imported?.importResults || {}));
        setImportData(imported?.sortedResults || {});
        setIsLoading(false);
      });
    } else {
      // Callback empty import
      navigate(links.configDuplication);
    }
    // eslint-disable-next-line
  }, []);

  const successfullImport = {
    [Tab.WALLET]: importData[Tab.WALLET]?.saved,
    [Tab.CUSTOM_EVENT]: importData[Tab.CUSTOM_EVENT]?.saved,
    [Tab.REWARDS]: importData[Tab.REWARDS]?.saved,
    [Tab.ACHIEVEMENTS]: importData[Tab.ACHIEVEMENTS]?.saved,
    [Tab.CAMPAIGNS]: importData[Tab.CAMPAIGNS]?.saved,
    [Tab.REFERRALS]: importData[Tab.REFERRALS]?.saved,
    [Tab.AUTOMATIONS]: importData[Tab.AUTOMATIONS]?.saved,
  };

  const unSuccessfullImport = {
    [Tab.WALLET]: importData[Tab.WALLET]?.unsaved,
    [Tab.CUSTOM_EVENT]: importData[Tab.CUSTOM_EVENT]?.unsaved,
    [Tab.REWARDS]: importData[Tab.REWARDS]?.unsaved,
    [Tab.ACHIEVEMENTS]: importData[Tab.ACHIEVEMENTS]?.unsaved,
    [Tab.CAMPAIGNS]: importData[Tab.CAMPAIGNS]?.unsaved,
    [Tab.REFERRALS]: importData[Tab.REFERRALS]?.unsaved,
    [Tab.AUTOMATIONS]: importData[Tab.AUTOMATIONS]?.unsaved,
  };
  const isAnySuccesfullImports = isAnyTableValue(successfullImport);
  const isAnyUnsuccesfullImports = isAnyTableValue(unSuccessfullImport);

  return (
    <>
      <div className={classes.backButtonWrapper}>
        <OLBackIcon link={links.configDuplication} />
        <Typography className={classes.backTitle}>
          {message({ id: "duplicateConfigurationInProgress" })}
        </Typography>
      </div>
      <div className={classes.wrapper}>
        <LoadingInterceptor isLoading={isLoading}>
          {isAnySuccesfullImports && (
            <SuccessfulImports successfullImport={successfullImport} />
          )}
          {isAnyUnsuccesfullImports && (
            <UnSuccessfulImports unSuccessfullImport={unSuccessfullImport} />
          )}
        </LoadingInterceptor>
        <div className={classes.buttonWrapper}>
          <OLButton
            variant="contained"
            onClick={() => navigate(links.configDuplication)}
            data-test-id="finish-import"
            disabled={isLoading}
          >
            {message({ id: "finish" })}
          </OLButton>
        </div>
      </div>
    </>
  );
};
